type CountryType = string;
type CityType = string;

type AkamaiLocationDataType = [CityType | '', CountryType | ''];

/**
 * adapt to x-akamai geo structure
 * x-akamai-geo
 */
export const getAkamaiCountryAndCity = (codes: string): AkamaiLocationDataType => {
    const [, country, city] = codes.split(',');

    const result: AkamaiLocationDataType = ['', ''];

    if (country) result[0] = country;
    if (city) result[1] = city;

    return result;
};
